import $ from 'jquery';
import debounce from 'lodash.debounce';
/**
 * Enables the captcha functionality.
 * @see https://docs.hcaptcha.com/invisible/#example-of-floating-badge
 */
const enableCaptchaFunctionality = () => {
    // Create the script to load the captcha API dynamically
    $('<script></script>').attr('src', 'https://js.hcaptcha.com/1/api.js?onload=onloadCaptcha').prop('async', true).prop('defer', true).appendTo('body');
    /**
     * The overlay badge.
     */
    const overlayBadge = $('.captcha-overlay-badge');
    /**
     * The overlay popup.
     */
    const overlayPopup = $('.captcha-overlay-popup');
    /**
     * Hides the popup after 3 seconds (debounced).
     */
    const debouncedHidePopup = debounce(_hidePopup, 3000);
    // Display the popup when mousing over the badge
    overlayBadge.on('mouseenter', () => {
        _displayPopup();
    });
    // Display the popup after touching the badge; hides the popup (debounced)
    overlayBadge.on('touchstart', () => {
        _displayPopup();
        debouncedHidePopup();
    });
    // Hides the popup when mousing away from the badge (debounced)
    overlayBadge.on('mouseleave', debouncedHidePopup);
    /**
     * Displays the popup, canceling any active delayed invocations for hiding the popup.
     */
    function _displayPopup() {
        overlayPopup.css('display', 'block');
        debouncedHidePopup.cancel();
    }
    /**
     * Hides the popup.
     */
    function _hidePopup() {
        overlayPopup.css('display', 'none');
    }
};
export default enableCaptchaFunctionality;
